import React from 'react'
import lostandfound from "../Img/lostandfound.webp"
import facevote from "../Img/vote.jpg"
import campus from "../Img/campus.png"

import weatherapp from "../Img/weatherapp.png";
import fithub from "../Img/gym.webp";
import gmm from "../Img/GMMimg.png";


import "./project.css";

import { NavLink } from 'react-router-dom';
// import Wallpaper from '../home/Wallpaper'

const Projects = () => {

    // const [scale, setscale] = useState(90);
    // const [value, setvalue] = useState(); // Start at white
    // const [scrol, setscrol] = useState();


    // const handleScroll = () => {

    //     const minScroll = 150;
    //     const maxScroll = 600;
    //     const minScale = 0;
    //     const maxScale = 90;

    //     const scrollTop = window.scrollY;

    //     let scaleValue;
    //     if (scrollTop <= minScroll) {
    //         scaleValue = maxScale;
    //     } else if (scrollTop >= maxScroll) {
    //         scaleValue = minScale;
    //     } else {
    //         const scrollFraction = (scrollTop - minScroll) / (maxScroll - minScroll);
    //         scaleValue = maxScale - scrollFraction * (maxScale - minScale);
    //     }

    //     setscale(Math.floor(scaleValue));


    // };

    // React.useEffect(() => {
    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);


    return (

        <>

            <div className='prjects bcg'>


                <div className='prj_latin'>

                    <h1> SOME OF THE MOST
                        IMPRESSIVE PROJECTS
                        I HAVE WORKED  </h1>

                    <p>Explore a selection of my web development projects that showcase my skills in building modern, responsive,
                        and user-friendly websites and applications. </p>

                </div>

                <div className='prjs_box'>

                    <div class="item">

                        <NavLink target="_blank" to="https://rahulbishnoi0014.github.io/gmm_by_rahul/">

                            {/* <div className='Pimg_box vote_back'>
                            </div> */}
                            <img class="Pimg" src={gmm} alt="P-img"></img>
                        </NavLink>
                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://rahulbishnoi0014.github.io/gmm_by_rahul/">

                                <h1>GMM Live Demo</h1>
                                <p>GMM Background Subtraction. Stauffer & Grimson, 1999 ·  Live Demo</p>

                                <table cellSpacing="0"  >
                                    <tr className='prj_tags'>
                                        <td><span> Category: </span></td>
                                        <td>Computer Vision</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Role: </span></td>
                                        <td>Implementation</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Tag: </span></td>
                                        <td>Machine Learning</td>
                                    </tr>
                                </table>

                            </NavLink>

                        </div>
                    </div>

                    <div class="item">

                        <NavLink target="_blank" to="https://weather-react-xufr.onrender.com/">

                            {/* <div className='Pimg_box vote_back'>
                            </div> */}
                            <img class="Pimg" src={weatherapp} alt="P-img"></img>
                        </NavLink>
                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://weather-react-xufr.onrender.com/">

                                <h1>WEATHER APP</h1>
                                <p>Develop a ReactJS weather app that utilizes a reliable API
                                    for weather forecasts, delivering an exceptional UI/UX experience.</p>

                                <table cellSpacing="0"  >
                                    <tr className='prj_tags'>
                                        <td><span> Category: </span></td>
                                        <td>Weather Forecast </td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Role: </span></td>
                                        <td> ReactJs dev.</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Tag: </span></td>
                                        <td> Project</td>
                                    </tr>
                                </table>

                            </NavLink>

                        </div>
                    </div>

                    <div class="item">

                        <NavLink target="_blank" to="https://github.com/Rahulbishnoi0014/GYM_Management_System">

                            {/* <div className='Pimg_box '>
                            </div> */}
                            <img class="Pimg" src={fithub} alt="P-img" />

                        </NavLink>

                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://github.com/Rahulbishnoi0014/GYM_Management_System">

                                <h1>FITHUB</h1>
                                <p>
                                    FITHUB streamlines gym operations with features like attendance tracking,
                                    face attendance, fees management, member management, and diet planning.
                                </p>

                                <table cellSpacing="0"  >
                                    <tr className='prj_tags'>
                                        <td><span> Category: </span></td>
                                        <td> GYM Management System</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Role: </span></td>
                                        <td> Full stack</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Tag: </span></td>
                                        <td>college project</td>
                                    </tr>
                                </table>




                            </NavLink>

                        </div>
                    </div>

                    <hr></hr>

                    <div class="item">

                        <NavLink target="_blank" to="https://github.com/Rahulbishnoi0014/LostAndFound">

                            {/* <div className='Pimg_box lostAndFound_back'>

                            </div> */}
                            <img class="Pimg" src={lostandfound} alt="P-img"></img>

                        </NavLink>
                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://github.com/Rahulbishnoi0014/LostAndFound">

                                <h1>Lost And Found</h1>
                                <p>Embark on a digital quest with our Lost and Found platform. Losing things just got a whole lot
                                    more
                                    interesting—and simple.</p>




                                <table cellSpacing="0"  >
                                    <tr className='prj_tags'>
                                        <td><span> Category: </span></td>
                                        <td>  Community Services</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Role: </span></td>
                                        <td> Full stack</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Tag: </span></td>
                                        <td> personal project</td>
                                    </tr>
                                </table>


                            </NavLink>

                        </div>
                    </div>
                    <hr></hr>


                    <div class="item">

                        <NavLink target="_blank" to="https://campus-ejs.onrender.com/">

                            {/* <div className='Pimg_box campus_back'>
                            </div> */}
                            <img class="Pimg" src={campus} alt="P-img"></img>

                        </NavLink>
                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://campus-ejs.onrender.com/">

                                <h1>CAMPUS</h1>
                                <p>Dive into the world of anonymous expression with our live platform—share anything, anytime. Your
                                    voice, your story, without the strings attached.(EJS is live)</p>

                                <table cellSpacing="0"  >
                                    <tr className='prj_tags'>
                                        <td><span> Category: </span></td>
                                        <td> Social media</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Role: </span></td>
                                        <td> Full stack</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Tag: </span></td>
                                        <td> college project</td>
                                    </tr>
                                </table>
                            </NavLink>
                        </div>
                    </div>
                    <hr></hr>





                    {/* <div class="item">

                        <NavLink target="_blank" to="https://facevotebyrahul.onrender.com">

                            
                                <img class="Pimg" src={facevote} alt="P-img"></img>
                        </NavLink>
                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://facevotebyrahul.onrender.com">

                                <h1>F A C E V O T E</h1>
                                <p>FACEVOTE is a delightful project designed to randomly
                                    select students for the sheer joy of voting.</p>

                                <table cellSpacing="0"  >
                                    <tr className='prj_tags'>
                                        <td><span> Category: </span></td>
                                        <td> voting system</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Role: </span></td>
                                        <td> ReactJs dev.</td>
                                    </tr>
                                    <tr className='prj_tags'>
                                        <td><span> Tag: </span></td>
                                        <td> Project</td>
                                    </tr>
                                </table>

                            </NavLink>

                        </div>
                    </div> */}




                    {/* <div class="item">

                        <NavLink target="_blank" to="https://github.com/Rahulbishnoi0014/speech-to-text">

                            <div className='Pimg_box gym_back'>


                                <img class="Pimg" src={speach} alt="P-img"></img>
                            </div>

                        </NavLink>
                        <div class="Ptxt">

                            <NavLink target="_blank" to="https://github.com/Rahulbishnoi0014/speech-to-text">

                                <h1>Speech to Text</h1>
                                <p>React wonders: Speak in 5 languages, watch it become text, and one-click copy to clipboard magic.
                                </p>
                                <p className='prj_tags'> <span> Category: </span>  </p>
                                <p className='prj_tags'><span>Role: Full stack</span> </p>
                                <p className='prj_tags'> <span>Tag: college project</span> </p>
                            </NavLink>

                        </div>
                    </div> */}


                </div>

            </div>

            <div className='prj_end'>
                <p>That’s all for now</p>
                <h1> Got a project in mind?</h1>
                <h1> Let’s talk</h1>
                {/* <p>+917015365005</p> */}

                <hr className='prj_end_line'></hr>

                <div className='contact'>
                    <div>
                        <p>Email address:</p>
                        <NavLink className="social_links" to={"mailto:rahulbhadu14@gmail.com"} target='_blank'>
                            <p>rahulbhadu14@gmail.com</p></NavLink>

                    </div>
                    <div>
                        <p>Phone number:</p>
                        <p>+91 7015365005</p>

                    </div>
                    <div>
                        <p>Other:</p>
                        <p>
                            {/* <NavLink className="social_links" to={"/"}>Mail</NavLink> */}
                            <NavLink className="social_links" to={"https://github.com/Rahulbishnoi0014"} target='_blank'>GitHub</NavLink>
                            <NavLink className="social_links" to={"https://www.linkedin.com/in/rahul-bishnoi-55a855218/"} target='_blank'>linkedIn</NavLink>


                        </p>

                    </div>
                </div>

            </div>


        </>

    )
}

export default Projects